import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import { NgOptimizedImage } from "@angular/common";
import {PaginatorComponent} from "../../../layout/paginator/paginator.component";
import {TableSorterHeaderDirective} from "../../../../directives/table-sorter/table-sorter-header.directive";
import {TableSorterDirective} from '../../../../directives/table-sorter/table-sorter.directive';
import {Paginator} from '../../../../tools/pagination/paginator';
import {TableSorter} from '../../../../tools/table-sorter/table-sorter';
import {LoaderService} from '../../../../services/loader/loader.service';
import {SnackbarService} from '../../../../services/snackbar/snackbar.service';
import {TranslationDomainService} from '../../../../services/translation-domain/translation-domain.service';
import {TranslationDomain} from '../../../../models/translation/translation-domain';
import {LangService} from '../../../../services/language/lang.service';
import {RouterLink} from '@angular/router';
import {IsGranted} from '../../../../decorator/is-granted';
import {MetaTitle} from '../../../../decorator/meta-title';
import {FormsModule} from '@angular/forms';
import {ListFilters} from '../../../../tools/list-filters/list-filters';
import {ListFilterService} from '../../../../services/list-filter/list-filter.service';

@Component({
  selector: 'app-translation-domain-list',
  imports: [
    PaginatorComponent,
    TableSorterHeaderDirective,
    TableSorterDirective,
    NgOptimizedImage,
    RouterLink,
    FormsModule
],
  templateUrl: './translation-domain-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './translation-domain-list.component.scss'
})
@IsGranted(['TRANSLATION_VIEW'])
@MetaTitle('Translations')
export class TranslationDomainListComponent implements OnInit {

  private timeout!: number;

  translationDomains: TranslationDomain[] = [];
  paginator: Paginator = new Paginator();
  tableSorter: TableSorter = new TableSorter('id', 'asc');

  filters: ListFilters;

  constructor(
    private loader: LoaderService,
    private snackbar: SnackbarService,
    private translationDomainService: TranslationDomainService,
    protected langService: LangService,
    private listFilterService: ListFilterService,
  ) {
    this.filters = listFilterService.createFilters({
      domain: 'string',
    }, this.paginator, this.tableSorter);
  }

  ngOnInit(): void {
    this.filters.init(() => this.fetchAll());
  }

  fetchAll(): void {
    this.loader.startLoading();

    const parameters: any = {...this.filters.toParams()};

    this.translationDomainService.findAll(parameters, this.paginator, this.tableSorter).subscribe((translationDomains) => {
      this.translationDomains = translationDomains;

      this.translationDomains.forEach(translationDomain => {
        translationDomain.locales.sort();
      });

      this.loader.stopLoading();
    })
  }

  onInputChange(): void {
    clearTimeout(this.timeout);

    this.timeout = setTimeout(() => {
      this.filters.onFilterChange();
    }, 500);
  }
}
